import styled from 'styled-components';
import { WrapperProps } from './types';

export const Container = styled.div`
  position: relative;
  z-index: 990;
`;

export const OutsideArea = styled.div`
  background-color: rgba(17, 17, 17, 0.4);
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
`;

export const Backdrop = styled(OutsideArea)`
  background-color: ${({ theme }) => theme.color.background.neutral.inverted};
  z-index: 990;
  transition-delay: 0.1s;
  transition: all 0.2s cubic-bezier(0.65, 0, 0.35, 1);
  opacity: 0;

  &.animated {
    opacity: 0.4;
  }
`;

export const Wrapper = styled.div<WrapperProps>`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  z-index: 999;
`;

export const Stage = styled.div`
  z-index: 1;
`;
